module.exports = __webpack_public_path__ + "img/img_login.1ecfce63.jpg";